var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-centerize"},[_c('h3',{staticClass:"reg pr-2"},[_vm._v(_vm._s(_vm.headerText))]),_c('ProjectSelect',{attrs:{"disabled":_vm.readonly,"projects":_vm.projects},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }